/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import * as Sentry from '@sentry/browser';
import { config } from '../store/modules/config';
import { getAuthenticatedHeaders } from '@/lib/authentication';

const { apiBaseUrl } = config;
const base = `${apiBaseUrl}/users`;

export async function fetchReferralUrl() {
  try {
    const authHeaders = await getAuthenticatedHeaders();
    const response = await axios.get(`${base}/referral-url`, authHeaders);
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
}

export async function sendReferralInvitation(email, name = '', message = '') {
  try {
    const authHeaders = await getAuthenticatedHeaders();
    const response = await axios.post(
      `${base}/referrals/send-invitation`, 
      { email, name, message }, 
      authHeaders
    );
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
}

export async function fetchReferralStatsCall() {
  try {
    const authHeaders = await getAuthenticatedHeaders();
    const response = await axios.get(`${base}/referrals/stats`, authHeaders);
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    return { count: 0 };
  }
}

export async function validateReferralCode(referralCode, paddleData) {
  if (localStorage.getItem('utmcat') || document.cookie.includes('utmcat=true')) {
    return {};
  }
  
  try {
    const response = await axios.post(
      `${base}/referralValidation`,
      { code: referralCode, paddleData },
      await getAuthenticatedHeaders({
        headers: {
          'Content-Type': 'application/json',
        },
      })
    );
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
}

export async function checkReferralCode(code) {
  try {
    const response = await axios.post(
      `${base}/referrals/checkCode`,
      { code },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
}
